import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CartItem } from "types";

// Define the state type
interface CartState {
  items: CartItem[];
}

// Define the initial state
const initialState: CartState = {
  items: [],
};

// Create the slice
const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addToCart: (state, action: PayloadAction<CartItem>) => {
      const existingItem = state.items.find(
        (item) => item.product_id === action.payload.product_id && item.variant_id === action.payload.variant_id
      );
      if (existingItem) {
        existingItem.quantity += action.payload.quantity;
      } else {
        state.items.push(action.payload);
      }
    },
    removeFromCart: (state, action: PayloadAction<string>) => {
      state.items = state.items.filter(
        (item) => item.product_id !== action.payload
      );
    },
    clearCart: (state) => {
      state.items = [];
    },
    updateCartItem: (
      state,
      action: PayloadAction<{ product_id: string; variant_id: string; quantity: number }>
    ) => {
      const item = state.items.find(
        (item) => item.product_id === action.payload.product_id && item.variant_id === action.payload.variant_id
      );
      if (item) {
        item.quantity = Math.max(1, action.payload.quantity); // Ensure at least 1 quantity
      }
    },
  },
});

// Export actions
export const { addToCart, removeFromCart, clearCart, updateCartItem } =
  cartSlice.actions;

// Export reducer
export default cartSlice.reducer;
